<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/member_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>會員專區</h1>
          <div class="banner-text-line"></div>
          <span>Members</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <!-- 登入後才能看到 -->
      <div v-if="isLogin" class="content">
        <!-- 上方切換選單 -->
        <!-- mobile 用 -->
        <div
          v-if="screenWidth <= 768"
          class="accordion mb-4 mt-4"
          id="insideMenuMobile"
        >
          <div class="card">
            <div class="card-header insideMenu-header" id="headingOne">
              <h2 class="mb-0">
                <button
                  class="btn btn-block text-left"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  {{ title }}
                  <i class="fas fa-angle-down fa-lg insideMenu-icon"></i>
                  <i class="fas fa-angle-up fa-lg insideMenu-icon"></i>
                </button>
              </h2>
            </div>

            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-parent="#insideMenuMobile"
            >
              <div>
                <div class="list-group list-bg" id="list-tab" role="tablist">
                  <a
                    v-for="(item, index) in listTitle"
                    :key="index"
                    class="list-group-item text-center"
                    :class="{ active: title === item.titleZh }"
                    :id="item.titleEn"
                    data-toggle="list"
                    role="tab"
                    :aria-controls="item.titleEn"
                    @click="setPage(item.titleZh)"
                    >{{ item.titleZh }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 上方切換選單 -->
        <!-- PC 用 -->
        <div v-if="screenWidth > 769" class="d-flex justify-content-center">
          <div
            class="list-group list-group-horizontal list-bg list-area rounded-pill"
            id="list-tab"
            role="tablist"
          >
            <a
              v-for="(item, index) in listTitle"
              :key="index"
              class="list-group-item text-center rounded-pill list-pointer"
              :class="{ active: title === item.titleZh }"
              :id="item.titleEn"
              data-toggle="list"
              role="tab"
              :aria-controls="item.titleEn"
              @click="setPage(item.titleZh)"
              >{{ item.titleZh }}</a
            >
            <!-- <router-link to="/inquire" class="list-group-item text-center rounded-pill list-pointer">報名查詢</router-link> -->
          </div>
        </div>
        <div class="tab-content" id="nav-tabContent">
          <div>
            <div class="content-title">
              <h2>
                {{ title }} <span v-if="title === '會員權限'"> - </span
                ><span v-if="title === '會員權限'" class="memberAuthority">
                  {{ showtext }}</span
                >
              </h2>
              <div class="bread">
                <router-link to="/">
                  <i class="fas fa-home fa-lg"></i>
                </router-link>
                <span>></span>
                <router-link to="/member"> 會員專區 </router-link>
                <span>></span>
                {{ title }}
              </div>
            </div>
            <!-- 分頁區 -->
            <!-- 會員權限分頁 -->
            <div v-if="title === '會員權限'" key="transition1">
              <!-- <div class="test">
                  測試狀態用
                  <select v-model="memberStatus">
                    <option value="10">信箱未驗證</option>
                    <option value="30">未上傳資料</option>
                    <option value="40">審核中</option>
                    <option value="50">審核未過</option>
                    <option value="60">未繳費</option>
                    <option value="70">正式會員</option>
                  </select>
                </div> -->
              <div class="content-contact">
                <div class="content-contact-border">
                  <div class="member-box">
                    <h3>
                      E-mail 帳號：<span>{{ MemberInfo.Email }}</span>
                    </h3>
                    <!-- 正式會員 -->
                    <div v-if="memberStatus === 70">
                      <h4>
                        會員身分：{{
                          MemberInfo.Position === "Doctor" ? "個人會員" : "學生"
                        }}
                      </h4>
                      <p>
                        已完成認證會員，有效日期：<span>{{
                          MemberInfo.EndOn | moment("YYYY.MM.DD")
                        }}</span
                        >到期。
                      </p>
                      <h4>會費紀錄</h4>
                      <div class="member-box-line"></div>
                      <div class="list">
                        <!-- <div class="item">
                            <div class="date">
                              <span class="staging">第1期</span>
                              <span
                                >{{ $moment(StartDate).format("YYYY") }}年</span
                              >
                            </div>
                            <div class="money">
                              <div>
                                <span>入會費</span>
                                <span
                                  >{{
                                    MemberInfo.Position === "Doctor"
                                      ? 1000
                                      : 500
                                  }}元</span
                                >
                              </div>
                              <div>
                                <span>當年會費</span>
                                <span
                                  >{{
                                    MemberInfo.Position === "Doctor"
                                      ? 1000
                                      : 500
                                  }}元</span
                                >
                              </div>
                            </div>
                            <div class="item_status">
                              <div>
                                <span>已繳費</span>
                              </div>
                              <div v-if="Membership.length == 0">
                                <a href="#" @click.prevent="goPrint"
                                  >列印收據</a
                                >
                              </div>
                            </div>
                          </div> -->
                        <div
                          class="item"
                          v-for="(memberShip, index) in feeList"
                          :key="memberShip.Id"
                        >
                          <div class="date">
                            <span>{{
                              $moment(memberShip.CreatedOn).format("YYYY/MM/DD")
                            }}</span>
                          </div>
                          <div class="money">
                            <div>
                              <span>
                                {{ memberShip.Title }}<br />
                                {{ memberShip.Memo }}
                              </span>
                            </div>
                          </div>
                          <div class="item_status">
                            <span> {{ memberShip.TotalAmount }}元</span>
                            <div v-if="index === 0">
                              <a
                                href="#"
                                class="print_link"
                                @click.prevent="goPrint(memberShip.Id)"
                                >列印收據</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="renewal" v-if="IsRenew">
                        <div class="money">
                          <!-- <span>未繳期數:共{{ TotalPay.Total }}期</span>
                            <span>總計:{{ TotalPay.Money }}</span> -->
                        </div>
                        <div class="contact-btnBlock">
                          <div class="item">
                            <div
                              class="btn blue-btn islogin single"
                              @click="renewalMember"
                            >
                              <a href="javascript:;">前往繳款</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 信箱未驗證 -->
                    <div v-if="memberStatus === 10">
                      <p>
                        若您未收到驗證信，同時垃圾信箱內也未收到，請點擊”寄送驗證信”
                      </p>
                      <div
                        class="btn blue-btn submission-btn btn-box"
                        @click="senMail"
                      >
                        <a class href="javascript:;">寄送驗證信</a>
                      </div>
                      <h4>會期時間</h4>
                      <div class="member-box-line"></div>
                      <div class="list">
                        <div class="item noLine">
                          <div class="date">
                            <span class="staging">尚無資料。</span>
                            <!-- <span>2020年</span> -->
                          </div>
                          <div class="money">
                            <div>
                              <!-- <span>入會費</span> -->
                              <!-- <span>5000元</span> -->
                            </div>
                            <div>
                              <!-- <span>當年會費</span> -->
                              <!-- <span>1000元</span> -->
                            </div>
                          </div>
                          <div class="item_status">
                            <!-- <span>已繳費</span> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 未填寫資料 -->
                    <div v-if="memberStatus === 20">
                      <p>尚未填寫入會申請，請切換至會員資料填寫。</p>
                    </div>
                    <!-- 未上傳資料 or 未繳費 -->
                    <div
                      v-if="
                        memberStatus === 30 &&
                        MemberInfo.AuditStatus !== 'Processing' &&
                        MemberInfo.StartOn === undefined
                      "
                    >
                      <h4>會員身分：{{ MemberInfo.Position | nameDisplay }}</h4>
                      <p>
                        已完成註冊，尚未繳款<br />
                        請前往完成付款<br />
                        如您已付款完成，請等候本會確認。
                      </p>
                      <div class="contact-btnBlock">
                        <div class="item">
                          <div
                            class="btn blue-btn islogin single"
                            @click="joinMember"
                          >
                            <a href="javascript:;">前往繳款</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        (memberStatus === 30 &&
                          MemberInfo.AuditStatus === 'Processing' &&
                          MemberInfo.Position === 'Student') ||
                        (memberStatus === 50 &&
                          MemberInfo.Position === 'Student')
                      "
                    >
                      <h4>會員身分：{{ MemberInfo.Position | nameDisplay }}</h4>
                      <p>已完成註冊，請上傳下方指定資料(PDF)</p>
                      <div class="file_item" v-if="isFailfile.dip">
                        <span>學生證影本</span>
                        <label v-show="!files[0]">
                          <span>上傳檔案</span>
                          <input
                            type="file"
                            @change="onFileChange($event, 0, 'dip')"
                            ref="file0"
                          />
                          <span>，檔案請小於2.0MB</span>
                        </label>
                        <div class="file_name" v-if="files[0]">
                          <div>
                            {{ files[0] }}
                          </div>
                          <div @click="deleteFile(0)">
                            <span>✖</span>
                            <span>刪除</span>
                          </div>
                        </div>
                      </div>
                      <div class="contact-btnBlock">
                        <div class="item">
                          <div
                            class="btn blue-btn islogin single"
                            @click="sendfile"
                          >
                            <a href="javascript:;">確認送出</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 審核中 -->
                    <div v-if="memberStatus === 40">
                      <p>請等候3-5個工作天，若有問題請聯絡我們。</p>
                      <div class="btn blue-btn submission-btn btn-box">
                        <router-link class to="/contactus"
                          >聯絡我們</router-link
                        >
                      </div>
                      <h4>會期時間</h4>
                      <div class="member-box-line"></div>
                      <div class="list">
                        <div class="item noLine">
                          <div class="date member">
                            <span class="staging"
                              >您已完成繳費，待資料完成審核，將立即開通！</span
                            >
                            <!-- <span>2020年</span> -->
                          </div>
                          <div class="money">
                            <div>
                              <!-- <span>入會費</span> -->
                              <!-- <span>5000元</span> -->
                            </div>
                            <div>
                              <!-- <span>當年會費</span> -->
                              <!-- <span>1000元</span> -->
                            </div>
                          </div>
                          <div class="item_status">
                            <!-- <span>已繳費</span> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 審核未過 -->
                    <div v-if="memberStatus === 50"></div>
                    <!-- 未繳費 -->
                    <div v-if="memberStatus === 60">
                      <p>尚未繳費，請點擊下方按鈕前往繳費。</p>
                      <div class="item">
                        <div
                          class="btn blue-btn islogin single"
                          @click="joinMember"
                        >
                          <a href="javascript:;">前往繳款</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 會員資料分頁 -->
            <div
              v-if="title === '會員資料' && MemberInfo.IsEmailValid"
              key="transition2"
            >
              <div class="content-contact">
                <div class="content-contact-border">
                  <div class="member-box">
                    <h3>
                      E-mail 帳號：<span>{{ MemberInfo.Email }}</span>
                    </h3>
                    <p v-if="!IsUpdated">
                      請您填寫以下入會申請書，以利完成入會申請，謝謝。
                    </p>
                    <h4 v-if="IsUpdated">修改會員資料</h4>
                    <h4 v-if="!IsUpdated">填寫入會申請</h4>
                    <div class="member-box-line"></div>
                    <div class="output">
                      <div class="input_span">
                        <span>中文姓名</span>
                        <input
                          type="text"
                          placeholder="請填寫中文姓名"
                          v-model="MemberInfo.Name"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                        />
                      </div>
                      <div class="input_span">
                        <span>英文姓名</span>
                        <input
                          type="text"
                          placeholder="請填寫英文姓名"
                          v-model="MemberInfo.EngName"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                        />
                      </div>
                      <div class="input_span">
                        <span>身分證字號</span>
                        <input
                          type="text"
                          placeholder="請填寫您的身分證字號"
                          v-model="MemberInfo.IDcard"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                        />
                      </div>
                      <div class="input_span">
                        <span>性別</span>
                        <select
                          name="sex"
                          v-model="MemberInfo.Gender"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                          class="sex"
                        >
                          <option value="null" selected disabled>
                            請選擇您的性別
                          </option>
                          <option value="M">男</option>
                          <option value="F">女</option>
                        </select>
                      </div>
                      <div class="input_span">
                        <span>出生年月日</span>
                        <input
                          type="date"
                          v-model="MemberInfo.Birthday"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                        />
                      </div>
                      <div class="input_span">
                        <span>通訊地址</span>
                        <div class="select">
                          <select name="City" v-model="selectCity" required>
                            <option value="null" selected disabled>
                              請選擇縣市
                            </option>
                            <option
                              v-for="(city, index) in CityArea"
                              :value="city"
                              :key="index"
                            >
                              {{ city }}
                            </option>
                          </select>
                          <select
                            name="District"
                            required
                            v-model="selectDistrict"
                          >
                            <option value="null" selected disabled>
                              請選擇鄉鎮市區
                            </option>
                            <option
                              v-for="(district, index) in DistrictArea"
                              :value="district"
                              :key="index"
                            >
                              {{ district }}
                            </option>
                          </select>
                          <input
                            type="text"
                            placeholder="請填寫完整地址"
                            v-model="MemberInfo.Address"
                          />
                        </div>
                      </div>
                      <div class="input_span">
                        <span>聯絡信箱</span>
                        <input
                          type="text"
                          placeholder="請填寫您的E-mail"
                          v-model="MemberInfo.ContactBox"
                        />
                      </div>
                      <div class="input_span">
                        <span>聯絡電話</span>
                        <input
                          type="text"
                          placeholder="請填寫您的聯絡電話"
                          v-model="MemberInfo.Telephone"
                        />
                      </div>
                      <div class="input_span">
                        <span>手機號碼</span>
                        <input
                          type="text"
                          placeholder="請填寫您的聯絡電話"
                          v-model="MemberInfo.Mobile"
                        />
                      </div>
                      <!-- <div class="input_span">
                          <span>住院醫師-訓練醫院*</span>
                          <div class="introduction">
                            <input
                              type="date"
                              v-model="MemberInfo.ResidentTrainStartOn"
                              :disabled="IsUpdated"
                              :class="{ updated: IsUpdated }"
                            />
                            <div>※訓練起始日</div>
                            <input
                              type="date"
                              v-model="MemberInfo.ResidentTrainEndOn"
                              :disabled="IsUpdated"
                              :class="{ updated: IsUpdated }"
                            />
                            <div>※訓練結束日</div>
                          </div>
                        </div>
                        <div class="input_span">
                          <span>視網膜專科訓練醫院*</span>
                          <div class="introduction">
                            <input
                              type="date"
                              v-model="MemberInfo.RetinaTrainStartOn"
                              :disabled="IsUpdated"
                              :class="{ updated: IsUpdated }"
                            />
                            <div>※訓練起始日</div>
                            <input
                              type="date"
                              v-model="MemberInfo.RetinaTrainEndOn"
                              :disabled="IsUpdated"
                              :class="{ updated: IsUpdated }"
                            />
                            <div>※訓練結束日</div>
                          </div>
                        </div> -->
                      <div class="input_span">
                        <span>會員身分</span>
                        <select
                          name="Position"
                          v-model="MemberInfo.Position"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                          class="sex"
                        >
                          <option value="None" selected disabled>
                            請選擇您的身分
                          </option>
                          <option value="Doctor">醫師</option>
                          <option value="Dentist">牙醫師</option>
                          <option value="DentalHygienist">口衛師</option>
                          <option value="DentistAssistant">牙助</option>
                          <option value="Nurse">護理師</option>
                          <option value="SpeechTherapist">語言治療師</option>
                          <option value="Nutritionist">營養師</option>
                          <option value="Caregiver">照服員</option>
                          <option value="Lecturer">講師</option>
                          <option value="Student">學生</option>
                          <!-- <option value="Other">其他</option> -->
                        </select>
                      </div>
                      <div
                        class="input_span"
                        v-if="MemberInfo.Position !== 'Student'"
                      >
                        <span>現職單位</span>
                        <input
                          type="text"
                          placeholder="請填寫您的目前服務的單位"
                          v-model="MemberInfo.Affiliation"
                        />
                      </div>
                      <!-- <div class="input_span" v-if="MemberInfo.identity === 'Doctor' || MemberInfo.identity === 'Other'">
                          <span>職稱</span>
                          <input
                            type="text"
                            placeholder="請填寫您的職稱"
                            v-model="MemberInfo.Position"
                          />
                        </div> -->
                      <div
                        class="input_span"
                        v-if="MemberInfo.Position !== 'Student'"
                      >
                        <span>最高學歷</span>
                        <input
                          type="text"
                          placeholder="請填寫您的最高學歷"
                          v-model="MemberInfo.Education"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                        />
                      </div>
                      <div
                        class="input_span"
                        v-if="MemberInfo.Position === 'Student'"
                      >
                        <span>目前就讀學校</span>
                        <input
                          type="text"
                          placeholder="請填寫您的就讀學校"
                          v-model="MemberInfo.Education"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                        />
                      </div>
                      <div
                        class="input_span"
                        v-if="MemberInfo.Position === 'Student'"
                      >
                        <span>就讀科系</span>
                        <input
                          type="text"
                          placeholder="請填寫您的目前就讀科系"
                          v-model="MemberInfo.Affiliation"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                        />
                      </div>
                      <div
                        class="input_span"
                        v-if="MemberInfo.Position === 'Student'"
                      >
                        <span>學生證字號</span>
                        <input
                          type="text"
                          placeholder="請填寫您的學生證字號"
                          v-model="MemberInfo.Diploma"
                          :disabled="IsUpdated"
                          :class="{ updated: IsUpdated }"
                        />
                      </div>
                      <div class="input_span">
                        <span>經歷</span>
                        <textarea
                          name=""
                          id=""
                          cols="30"
                          rows="10"
                          v-model="MemberInfo.Introduction"
                        ></textarea>
                      </div>
                      <!-- <div class="input_span">
                          <span>畢業證書字號</span>
                          <input
                            type="text"
                            placeholder="請填寫您的畢業證書字號"
                            v-model="MemberInfo.Diploma"
                            :disabled="IsUpdated"
                            :class="{ updated: IsUpdated }"
                          />
                        </div>
                        <div class="input_span">
                          <span>醫師證書字號</span>
                          <input
                            type="text"
                            placeholder="請填寫您的醫師證書字號"
                            v-model="MemberInfo.Certification"
                            :disabled="IsUpdated"
                            :class="{ updated: IsUpdated }"
                          />
                        </div>
                        <div class="input_span">
                          <span>專科醫師字號</span>
                          <input
                            type="text"
                            placeholder="請填寫您的專科醫師字號"
                            v-model="MemberInfo.SpecialistNumber"
                            :disabled="IsUpdated"
                            :class="{ updated: IsUpdated }"
                          />
                        </div> -->
                      <div
                        class="detail"
                        v-if="MemberInfo.Position !== 'None' && !IsUpdated"
                      >
                        <div class="box">
                          <div class="">
                            <h4>入會費用</h4>
                            <div class="member-box-line"></div>
                          </div>
                          <div class="cost-container">
                            <div class="cost">
                              <div class="title"></div>
                              <ul class="signtpye">
                                <li>
                                  <span>入會費</span>
                                  <span
                                    >NTD
                                    {{ MemberInfo.Position | feeDisplay }}</span
                                  >
                                </li>
                                <li>
                                  <span>常年會費</span>
                                  <span
                                    >NTD
                                    {{ MemberInfo.Position | feeDisplay }}</span
                                  >
                                </li>
                              </ul>
                            </div>
                            <div class="global_title nomb"></div>
                            <div class="total">
                              <span>小計</span>
                              <span
                                >NTD
                                {{
                                  MemberInfo.Position === "Student"
                                    ? "1000"
                                    : "2000"
                                }}</span
                              >
                            </div>
                          </div>
                          <!-- <div class="">
                              <h4>入會費用</h4>
                              <div class="member-box-line"></div>
                            </div> -->
                          <!-- <div class="cost-container">
                              <div class="input_span">
                                <select v-model="payType">
                                  <option value="null" selected disabled>
                                    請選款方式
                                  </option> -->
                          <!-- <option value="0">臨櫃轉帳</option> -->
                          <!-- <option value="1">線上 ATM 轉帳</option>
                                  <option value="2">信用卡</option>
                                </select>
                              </div>
                            </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="contact-btnBlock">
                      <div class="item">
                        <div
                          class="btn blue-btn islogin"
                          @click.prevent="updateMember"
                        >
                          <a href="#">{{
                            IsUpdated ? "完成送出" : "送出並繳費"
                          }}</a>
                        </div>
                      </div>
                      <div class="item">
                        <div
                          class="btn white-btn islogin"
                          @click.prevent="resetMember"
                        >
                          <a href="#">重新填寫</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 活動繳費紀錄分頁 -->
            <div
              v-if="title === '活動訂單(收據)' && MemberInfo.IsEmailValid"
              key="transition3"
            >
              <div
                class="member-wrap infinite-scroll"
                v-infinite-scroll="loadMore"
                infinite-scroll-disabled="busy"
                infinite-scroll-distance="0"
                v-if="payedEvent && payedEvent.length > 0"
              >
                <template v-for="item in payedEvent">
                  <div class="member-activity" :key="item.Id">
                    <div class="member-activity-info">
                      <div class="img">
                        <img
                          v-if="item.ActivityPicture"
                          :src="item.ActivityPicture"
                          :alt="item.Title"
                        />
                        <img
                          v-else
                          src="../assets/images/continuing_pic.jpg"
                          alt="活動圖片"
                        />
                      </div>
                      <div class="date">
                        <div class="eventCard-date">
                          <div class="eventCard-date-month">
                            <div class="day">
                              {{
                                item.StartOn | moment("YYYY-MM-DD") | dayFormat
                              }}
                            </div>
                            <div class="month">
                              {{
                                item.StartOn
                                  | moment("YYYY-MM-DD")
                                  | monthFormat
                              }}
                            </div>
                          </div>
                          <div class="eventCard-date-year">
                            {{
                              item.StartOn | moment("YYYY-MM-DD") | yearFormat
                            }}
                          </div>
                        </div>
                        <div class="text-center week">
                          {{ item.StartOn | weekFormat }}
                        </div>
                        <div class="eventCard-detail-tag orange">報名活動</div>
                      </div>
                    </div>
                    <div class="member-activity-content">
                      <h3>{{ item.Title }}</h3>
                      <ul class="member-activity-ul list-unstyled">
                        <li>訂單編號：{{ item.Number }}</li>
                        <li>
                          活動時間：{{
                            item.ActivityStartOn | moment("YYYY.MM.DD")
                          }}~{{ item.ActivityEndOn | moment("YYYY.MM.DD") }}
                        </li>
                        <li>活動費用：{{ item.TotalAmount }}</li>
                        <li>
                          繳費資訊：{{ item.IsPaid ? "已繳費" : "未繳費" }}
                          <br />
                          <a
                            v-if="item.IsPaid"
                            href="#"
                            class="print_link"
                            @click.prevent="goPrint(item.Id)"
                            >列印收據</a
                          >
                        </li>
                      </ul>
                      <!-- <div
                          class="newsCard-content-detail"
                          v-show="item.StartOn"
                        >
                          <a href="#" @click.prevent="goDetail(item.Id)"
                            >查看詳情</a
                          >
                        </div> -->
                    </div>
                  </div>
                </template>
              </div>
              <div class="content-contact" v-else>
                <div class="content-contact-border">
                  <div class="member-box">
                    <h3>目前沒有內容</h3>
                  </div>
                </div>
              </div>
            </div>
            <!-- 活動紀錄(投稿)分頁 -->
            <div
              v-if="title === '活動紀錄(投稿)' && MemberInfo.IsEmailValid"
              key="transition8"
            >
              <div
                class="member-wrap infinite-scroll"
                v-infinite-scroll="loadMoreRecord"
                infinite-scroll-disabled="busyRecord"
                infinite-scroll-distance="0"
                v-if="eventRecord && eventRecord.length > 0"
              >
                <template v-for="item in eventRecord">
                  <div class="member-activity" :key="item.Id">
                    <div class="member-activity-info">
                      <div class="img">
                        <img
                          v-if="item.ActivityPicture"
                          :src="item.ActivityPicture"
                          :alt="item.ActivityTitle"
                        />
                        <img
                          v-else
                          src="../assets/images/continuing_pic.jpg"
                          alt="活動圖片"
                        />
                      </div>
                      <div class="date">
                        <div class="eventCard-date">
                          <div class="eventCard-date-month">
                            <div class="day">
                              {{
                                item.ActivityStartOn
                                  | moment("YYYY-MM-DD")
                                  | dayFormat
                              }}
                            </div>
                            <div class="month">
                              {{
                                item.ActivityStartOn
                                  | moment("YYYY-MM-DD")
                                  | monthFormat
                              }}
                            </div>
                          </div>
                          <div class="eventCard-date-year">
                            {{
                              item.ActivityStartOn
                                | moment("YYYY-MM-DD")
                                | yearFormat
                            }}
                          </div>
                        </div>
                        <div class="text-center week">
                          {{ item.ActivityStartOn | weekFormat }}
                        </div>
                        <div class="eventCard-detail-tag orange">報名活動</div>
                      </div>
                    </div>
                    <div class="member-activity-content">
                      <h3>{{ item.ActivityTitle }}</h3>
                      <ul class="member-activity-ul list-unstyled">
                        <li>
                          報名代碼：{{ item.Number }}
                          <a
                            class="btn blue-btn"
                            style="font-size: 14px; width: auto; color: white"
                            v-show="item.Number"
                            href="#"
                            @click.prevent="openQRPop(item.Number)"
                            >QR Code</a
                          >
                        </li>
                        <li>
                          活動時間：{{
                            item.ActivityStartOn | moment("YYYY.MM.DD")
                          }}~{{ item.ActivityEndOn | moment("YYYY.MM.DD") }}
                        </li>
                      </ul>
                      <div class="newsCard-content-detail">
                        <!-- <a href="#" @click.prevent="goSubmission(item)"
                          >去投稿</a
                        > -->
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="content-contact" v-else>
                <div class="content-contact-border">
                  <div class="member-box">
                    <h3>目前沒有內容</h3>
                  </div>
                </div>
              </div>
            </div>
            <!-- 修改密碼分頁 -->
            <div
              v-if="title === '修改密碼' && MemberInfo.IsEmailValid"
              key="transition4"
            >
              <div class="content-contact">
                <div class="content-contact-border">
                  <div class="member-box">
                    <h3>
                      E-mail 帳號：<span>{{ MemberInfo.Email }}</span>
                    </h3>
                    <h4>修改密碼</h4>
                    <div class="input_span">
                      <span>請輸入舊密碼</span>
                      <input
                        type="password"
                        placeholder="請填寫舊密碼"
                        v-model.trim="changePasswordData.OldPwd"
                        name="email"
                      />
                    </div>
                    <div class="input_span">
                      <span>請輸入新密碼</span>
                      <input
                        type="password"
                        placeholder="請填寫新密碼"
                        v-model.trim="changePasswordData.NewPwd"
                        name="password"
                      />
                    </div>
                    <div class="input_span">
                      <span>再次輸入密碼</span>
                      <input
                        type="password"
                        placeholder="再次輸入同上填寫的密碼"
                        v-model.trim="changePasswordData.CheckPwd"
                        name="password2"
                      />
                    </div>
                    <div class="input_span fs">
                      <span>請輸入驗證碼</span>
                      <div class="id">
                        <input
                          type="text"
                          placeholder="請輸入驗證碼"
                          v-model="InputId"
                        />
                        <Sidentify :identifyCode="identifyCode"></Sidentify>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          width="35"
                          height="35"
                          viewBox="0 0 172 172"
                          style="fill: #000000"
                          @click="refreshCode"
                        >
                          <g
                            fill="none"
                            fill-rule="none"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                          >
                            <path
                              d="M0,172v-172h172v172z"
                              fill="none"
                              fill-rule="nonzero"
                            />
                            <g fill="#333333" fill-rule="evenodd">
                              <g id="surface1">
                                <path
                                  d="M109.82357,31.85808c-13.10156,-5.76693 -27.88281,-6.66276 -41.62826,-2.32357c-26.11914,8.23047 -43.05599,33.00586 -41.29232,60.27278l-17.83268,1.17578c-2.29557,-35.5254 19.79232,-67.7754 53.75,-78.4974c19.87631,-6.27083 41.43229,-4.08724 59.71289,5.79492l17.10482,-18.2806l4.56315,50.69857l-53.69401,1.79167zM109.15169,159.51433c-7.5306,2.35156 -15.34115,3.55533 -23.0957,3.55533c-12.65365,0 -25.22331,-3.27539 -36.5612,-9.37825l-17.13281,18.30859l-4.53515,-50.69857l53.66601,-1.79167l-19.28841,20.63217c13.04557,5.73893 27.82682,6.66276 41.57226,2.32356c26.11914,-8.25846 43.08399,-33.06185 41.32031,-60.27278l17.80469,-1.17578c2.35156,35.4694 -19.76433,67.7474 -53.75,78.4974z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div class="contact-btnBlock">
                      <div class="item">
                        <div
                          class="btn blue-btn islogin"
                          @click="changePassword"
                        >
                          <a href="javascript:;">完成送出</a>
                        </div>
                      </div>
                      <div class="item">
                        <div class="btn white-btn islogin" @click="Reset">
                          <a href="javascript:;">重新填寫</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 投稿紀錄分頁 -->
            <div
              v-if="title === '投稿紀錄' && MemberInfo.IsEmailValid"
              key="transition5"
            >
              <div class="supervisory-btnBlock">
                <template v-for="(item, index) in ContributionList">
                  <button
                    v-if="index === 0"
                    class="btn btn-supervisory active"
                    :key="'btnBlock' + index"
                    @click="setSupervisory(index)"
                    :data-id="index"
                  >
                    {{ item.Title }}
                  </button>
                  <button
                    v-else
                    class="btn btn-supervisory"
                    :key="'btnBlock' + index"
                    @click="setSupervisory(index)"
                    :data-id="index"
                  >
                    {{ item.Title }}
                  </button>
                </template>
              </div>
              <div class="member-table">
                <table class="table-rwd">
                  <!-- title部分 -->
                  <tr>
                    <th class="table-title table-underline-title">投稿日期</th>
                    <th class="table-space table-underline-title"></th>
                    <th class="table-title table-underline-title">投稿分類</th>
                    <th class="table-space table-underline-title"></th>
                    <th class="table-title table-underline-title">投稿編號</th>
                    <th class="table-space table-underline-title"></th>
                    <th class="table-title table-underline-title">投稿題目</th>
                    <th class="table-space table-underline-title"></th>
                    <th class="table-title table-underline-title">投稿名稱</th>
                    <th class="table-space table-underline-title"></th>
                    <th class="table-title table-underline-title">投稿狀態</th>
                  </tr>

                  <!-- 內容部分 -->
                  <tr
                    v-for="(item, index) in filterContributionList"
                    :key="index"
                  >
                    <td
                      data-th="投稿日期"
                      class="table-content table-underline"
                    >
                      {{ item.Date }}
                    </td>
                    <td class="table-space"></td>
                    <td
                      data-th="投稿分類"
                      class="table-content table-underline"
                    >
                      <div
                        class="eventCard-detail-tag green"
                        v-if="item.Type === '研討會投稿'"
                      >
                        研討會投稿
                      </div>
                      <div
                        class="eventCard-detail-tag orange"
                        v-if="item.Type === '專題投稿'"
                      >
                        專題投稿
                      </div>
                      <div
                        class="eventCard-detail-tag skyBlue"
                        v-if="item.Type === '雜誌投稿'"
                      >
                        雜誌投稿
                      </div>
                    </td>
                    <td class="table-space"></td>
                    <td
                      data-th="投稿編號"
                      class="table-content table-underline"
                    >
                      {{ item.Number }}
                    </td>
                    <td class="table-space"></td>
                    <td
                      data-th="投稿題目"
                      class="table-content table-underline"
                    >
                      {{ item.Title }}
                    </td>
                    <td class="table-space"></td>
                    <td
                      data-th="投稿名稱"
                      class="table-content table-underline"
                    >
                      {{ item.Content }}
                    </td>
                    <td class="table-space"></td>
                    <td
                      data-th="投稿狀態"
                      class="table-content table-underline text-center"
                    >
                      {{ item.Status ? "審核完成" : "等候審核" }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <!-- 會員優惠分頁 -->
            <div
              v-if="title === '會員優惠' && MemberInfo.IsEmailValid"
              key="transition6"
            >
              <div class="member-wrap">
                <div
                  class="member-discount-card"
                  v-for="(item, index) in discountData"
                  :key="index"
                >
                  <div class="title">{{ item.Title }}</div>
                  <div class="discount-content">
                    <div class="img">
                      <img :src="item.Image" alt="廠商logo" />
                    </div>
                    <div class="discount-text">
                      <div class="discount">
                        {{ item.discount }}
                      </div>
                      <div class="info">
                        電話：{{ item.tel }}<br />
                        地址：{{ item.address }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 如果信箱未驗證顯示這邊 -->
            <div
              v-if="!MemberInfo.IsEmailValid && title !== '會員權限'"
              key="transition7"
            >
              <div class="content-contact">
                <div class="content-contact-border">
                  <div class="member-box">
                    <h3>
                      E-mail 帳號：<span>{{ MemberInfo.Email }}</span>
                    </h3>
                    <p>您尚未完成信箱認證，請先完成信箱認證。</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-back">
              <router-link to="/">
                回首頁
                <img src="../assets/images/icon/back_icon.png" alt="回首頁" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 沒登入的話顯示這邊 -->
      <div v-if="!isLogin" class="content">
        <div class="content-contact">
          <div class="content-contact-border no-Login">
            <h3>您尚未登入，請先登入會員</h3>
            <div class="btn blue-btn" @click.prevent="openLoginbox">
              <a class href="javascript:;"> 會員登入 </a>
            </div>
          </div>
        </div>
      </div>
      <form :action="PaymentUrl" id="submitForm" method="post">
        <input type="hidden" name="OrderId" v-model="payInfo.OrderId" />
        <input type="hidden" name="Token" v-model="payInfo.Token" />
        <input type="hidden" name="ReturnUrl" v-model="payInfo.ReturnUrl" />
        <input class="d-none" type="submit" value="送出表單" id="submitData" />
      </form>
    </div>
    <Popup v-if="openQR">
      <div class="popupPayTypeSuccess">
        <div class="mb-3">
          <qrcode-vue :value="qr.value" :size="qr.size" level="H" />
        </div>
        <div
          class="btn blue-btn submission-btn"
          @click.prevent="openQR = false"
        >
          <a class href="javascript:;">關閉</a>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import $ from 'jquery';
import API from '@/assets/api/member';
import activityApi from '@/assets/api/activity';
import Sidentify from '@/components/Identify.vue';
import Popup from '@/components/Popup.vue';
import QrcodeVue from 'qrcode.vue';
// import MagazineCard from '@/components/MagazineCard.vue';
// import EventCard from '@/components/EventCard.vue';
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-extraneous-dependencies
import Common from '@/common';
import BG from '../assets/images/index_bg_big.png';

export default {
  // name: 'Activity',
  components: {
    // MagazineCard,
    // EventCard,
    Sidentify,
    QrcodeVue,
    Popup,
  },
  data() {
    return {
      BG,
      title: '會員權限',
      Submission: false,
      nowIndex: 0,
      // eslint-disable-next-line global-require
      bgImage: require('@/assets/images/activity.png'),
      listTitle: [
        {
          titleZh: '會員權限',
          titleEn: 'member0',
        },
        {
          titleZh: '會員資料',
          titleEn: 'member1',
        },
        {
          titleZh: '活動訂單(收據)',
          titleEn: 'member2',
        },
        {
          titleZh: '活動紀錄(投稿)',
          titleEn: 'member6',
        },
        {
          titleZh: '修改密碼',
          titleEn: 'member3',
        },
        // {
        //   titleZh: '投稿紀錄',
        //   titleEn: 'member4',
        // },
        // {
        //   titleZh: '會員優惠',
        //   titleEn: 'member5',
        // },
      ],
      categrory: [
        {
          Id: '',
          Name: '全部活動',
          Title: '全部',
        },
        {
          Id: 'bb941e83-cedd-4bc1-b2a2-127688844b49',
          Name: '學術研討會',
          // Title: 'International',
        },
        {
          Id: 'e3ca867b-e423-4632-b7b5-f8e361d73f7e',
          Name: '會員大會',
          // Title: 'Domestic',
        },
        {
          Id: '9c6e32c0-1ed6-44c4-bd0d-ed5e9a949ade',
          Name: '相關合辦活動',
          // Title: 'Annual_meeting',
        },
        {
          Id: '172a1a46-596a-4c07-8ba9-51b6a778c97d',
          Name: '口腔衛生人員繼續教育',
          // Title: 'Mid_meeting',
        },
      ],
      events: [
        {
          Id: '9acaddasdhhyth',
          Type: 'International',
          // eslint-disable-next-line global-require
          Image: require('@/assets/images/continuing_pic.jpg'),
          CategoryId: 'bb941e83-cedd-4bc1-b2a2-127688844b49',
          Title: 'APAO 2019',
          Date: '2019-03-01',
          StartTime: '1551369600',
          Location: 'Bangkok Thailand',
          Organizer: '哈哈',
        },
        {
          Id: '134dfy56yyuk',
          Type: 'Domestic',
          // eslint-disable-next-line global-require
          Image: require('@/assets/images/continuing_pic.jpg'),
          CategoryId: 'e3ca867b-e423-4632-b7b5-f8e361d73f7e',
          Title: '視網膜學會108年第一次<南區>醫師繼續教育',
          Date: '2019-03-01~2019-03-02',
          StartTime: '1551369600',
          Location: '高雄長坑紀念醫院-湖畔星光1樓星光聽',
          Organizer: '哈哈',
        },
        {
          Id: '1231sdfs756887i',
          Type: 'Annual',
          // eslint-disable-next-line global-require
          Image: require('@/assets/images/continuing_pic.jpg'),
          CategoryId: '9c6e32c0-1ed6-44c4-bd0d-ed5e9a949ade',
          Title: '第59次年度學術研討會',
          Date: '2019-03-01',
          StartTime: '1551369600',
          Location: '台大醫院國際會議中心',
          Organizer: '中華民國眼科醫學會',
        },
        {
          Id: '123sdfsdfrt',
          Type: 'Mid',
          // eslint-disable-next-line global-require
          Image: require('@/assets/images/continuing_pic.jpg'),
          CategoryId: 'e3ca867b-e423-4632-b7b5-f8e361d73f7e',
          Title: '第54次學術研討會',
          Date: '2019-03-01',
          StartTime: '1551369600',
          Location: '台南大億麗緻酒店',
          Organizer: '中台南奇美醫院永康院區眼科部',
        },
        {
          Id: '12f567usdfsa',
          Type: 'International',
          // eslint-disable-next-line global-require
          Image: require('@/assets/images/continuing_pic.jpg'),
          CategoryId: '172a1a46-596a-4c07-8ba9-51b6a778c97d',
          Title: 'APAO 2019',
          Date: '2019-03-01',
          StartTime: '1551369600',
          Location: 'Bangkok Thailand',
          Organizer: '中華民國眼科醫學會',
        },
      ],
      popupSet: {},
      identifyCode: '',
      identifyCodes: '23456789ABCDEFGHJKMNPQRSTUVWXYZ',
      InputId: '',
      changePasswordData: {
        OldPwd: '',
        NewPwd: '',
        CheckPwd: '',
      },
      discountData: [
        // {
        //   Title: '老爺酒店(北投館)',
        //   // eslint-disable-next-line global-require
        //   Image: require('@/assets/images/hotel.png'),
        //   discount: '平日入住優惠 75折 假日入住優惠 85折',
        //   tel: '(02)2784-6788',
        //   address: '台北市北投區實踐路1段31號',
        // },
        // {
        //   Title: '星巴克咖啡館(北投館)',
        //   // eslint-disable-next-line global-require
        //   Image: require('@/assets/images/coffee.png'),
        //   discount: '星冰樂買一送一 其他商品 9折',
        //   tel: '(02)2784-6788',
        //   address: '台北市北投區實踐路1段31號',
        // },
        // {
        //   Title: '老爺酒店(北投館)',
        //   // eslint-disable-next-line global-require
        //   Image: require('@/assets/images/hotel.png'),
        //   discount: '平日入住優惠 75折 假日入住優惠 85折',
        //   tel: '(02)2784-6788',
        //   address: '台北市北投區實踐路1段31號',
        // },
      ],
      ContributionList: [
        {
          Title: '全部投稿紀錄',
        },
        {
          Title: '雜誌投稿',
        },
        {
          Title: '專題投稿',
        },
        {
          Title: '研討會投稿',
        },
      ],
      ContributionListData: [],
      payedEvent: [],
      eventRecord: [],
      memberStatus: '70',
      CityArea: [],
      DistrictArea: [],
      selectCity: 'null',
      selectDistrict: 'null',
      MemberInfo: {
        Id: '', // GID
        Email: '', // 帳號
        Name: '', // 中文姓名
        EngName: '', // 英文姓名
        Birthday: '', // 出生年月日
        IDcard: '', // 身分證
        Affiliation: '', // 服務單位
        Position: '', // 職稱
        Education: '', // 畢業學校
        Diploma: '', // 畢業證書字號
        Certification: '', // 醫生證書字號
        SpecialistNumber: '', // 專科醫師字號
        ContactBox: '', // Email
        Gender: '', // 性別
        Telephone: '', // 電話
        Mobile: '', // 手機
        Country: '', // 國家
        Province: '', // 省
        City: '', // 城市
        District: 'null', // 地區
        ZipCode: '', // 區碼
        Address: '', // 詳細地址
        Introducer: '', // 推薦人
        IntroducerEmail: '', // 推薦人
        SecondIntroducer: '', // 推薦人
        SecondIntroducerEmail: '', // 推薦人
        ResidentTrainStartOn: '', // 訓練起始時間
        ResidentTrainEndOn: '', // 訓練結束時間
        RetinaTrainStartOn: '', // 訓練起始時間
        RetinaTrainEndOn: '', // 訓練結束時間
        identity: '', // 身分
        Introduction: '', // 學經歷
      },
      IsUpdated: false,
      token: '',
      isLogin: false,
      nowPage: 1,
      nowPageRecord: 1,
      busy: false, // true觸發載入，false停止載入
      busyRecord: false, // true觸發載入，false停止載入
      totalPage: 1,
      totalPageRecord: 1,
      payInfo: {
        OrderId: 0,
        Token: '',
        ReturnUrl: '',
      },
      PaymentUrl: '',
      isFailfile: {
        dip: true,
      },
      files: ['', '', '', ''],
      StartDate: '',
      EndDate: '',
      TotalPay: {},
      feeList: [],
      IsRenew: false,
      qr: {
        value: '123',
        size: 300,
      },
      openQR: false,
    };
  },
  methods: {
    setFilter(id) {
      const vm = this;
      vm.nowTag = id;
    },
    setSupervisory(index) {
      const vm = this;
      $('.btn-supervisory').removeClass('active');
      // eslint-disable-next-line no-restricted-globals
      $(event.target).addClass('active');
      // eslint-disable-next-line no-restricted-globals
      // console.log(event.target.getAttribute('data-id'), index, event.target);
      vm.nowIndex = index;
    },
    setPage(text) {
      const vm = this;
      $('#collapseOne').collapse('hide');
      vm.title = text;
      vm.nowTag = '';
      vm.nowIndex = 0;
      if (vm.title === '投稿紀錄') {
        $('.btn-supervisory').removeClass('active');
        $('*[data-id="0"]').addClass('active');
      }

      // eslint-disable-next-line no-restricted-globals
    },
    openLoginbox() {
      // const vm = this;
      // eslint-disable-next-line no-shadow
      const Loginbox = document.getElementById('loginbox');
      // console.log(Loginbox);
      const tops = $(document).scrollTop();
      $(document).bind('scroll', () => {
        $(document).scrollTop(tops);
      });
      Loginbox.style.display = 'flex';
    },
    /* 圖形驗證 */
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
      // console.log("當前驗證碼==", this.identifyCode);
    },
    makeCode(o, length) {
      for (let i = 0; i < length; i += 1) {
        this.identifyCode += o[this.randomNum(0, o.length)];
      }
    },
    Reset() {
      const vm = this;
      vm.changePasswordData = {
        OldPwd: '',
        NewPwd: '',
        CheckPwd: '',
      };
    },
    changePassword() {
      const vm = this;
      if (
        vm.changePasswordData.OldPwd === ''
        || vm.changePasswordData.NewPwd === ''
        || vm.changePasswordData.CheckPwd === ''
      ) {
        vm.$swal({
          icon: 'warning',
          text: '欄位不得為空',
          confirmButtonText: '確定',
        });
      } else if (
        vm.changePasswordData.NewPwd !== vm.changePasswordData.CheckPwd
      ) {
        vm.$swal({
          icon: 'warning',
          text: '密碼不一致 請再輸入一次!',
          confirmButtonText: '確定',
        });
        vm.changePasswordData.NewPwd = '';
        vm.changePasswordData.CheckPwd = '';
      } else if (vm.CheckId === '') {
        vm.$swal({
          icon: 'warning',
          text: '請輸入驗證碼!',
          confirmButtonText: '確定',
        });
        vm.refreshCode();
      } else if (vm.InputId !== vm.identifyCode) {
        vm.$swal({
          icon: 'warning',
          text: '驗證碼輸入錯誤，請重新輸入!',
          confirmButtonText: '確定',
        });
        vm.refreshCode();
      } else {
        vm.$store.dispatch('updateLoading', true);
        API.ResetPassword(vm.token, vm.changePasswordData).then((res) => {
          vm.$store.dispatch('updateLoading', false);
          if (res.status === 200) {
            vm.$swal({
              icon: 'success',
              text: '修改成功，請重新登入',
              confirmButtonText: '確定',
            }).then(() => {
              vm.changePasswordData.OldPwd = '';
              vm.changePasswordData.NewPwd = '';
              vm.changePasswordData.CheckPwd = '';
              vm.InputId = '';
              vm.refreshCode();
              Common.setCookie('token', '', -1);
              window.location.reload();
            });
          } else {
            vm.$swal({
              icon: 'warning',
              text: res.data.Message,
              confirmButtonText: '確定',
            });
          }
        });
      }
    },
    goDetail(id) {
      const vm = this;
      vm.$router.push(`/member/${id}`);
      // console.log(id);
    },
    goSubmission(item) {
      const vm = this;
      activityApi.getTopic(item.Id).then((res) => {
        if (res.status == 200) {
          if (res.data.Data.length === 0) {
            vm.$swal({
              icon: 'warning',
              text: '本活動無法投稿',
              confirmButtonText: '確定',
            });
          } else {
            vm.$router.push(`/submission/${item.Number}`);
          }
        }
      });
    },
    updateMember() {
      const vm = this;
      // let params;
      // if (vm.IsUpdated) {
      //   params = {
      //     Id: vm.MemberInfo.Id,
      //     Email: vm.MemberInfo.Email,
      //     City: vm.MemberInfo.City,
      //     District: vm.MemberInfo.District,
      //     Address: vm.MemberInfo.Address,
      //     ContactBox: vm.MemberInfo.ContactBox,
      //     Mobile: vm.MemberInfo.Mobile,
      //     Affiliation: vm.MemberInfo.Affiliation,
      //     Position: vm.MemberInfo.Position,
      //     Introduction: vm.MemberInfo.Introduction,
      //   };
      // } else {
      //   params = vm.MemberInfo;
      // }
      // console.log(vm.MemberInfo);
      if (
        vm.MemberInfo.Name === ''
        || vm.MemberInfo.EngName === ''
        || vm.MemberInfo.IDcard === ''
        || vm.MemberInfo.Gender === 'null'
        || vm.MemberInfo.Birthday === ''
        || vm.MemberInfo.Address === ''
        || vm.MemberInfo.ContactBox === ''
        || vm.MemberInfo.Telephone === ''
        || vm.MemberInfo.Mobile === ''
        || vm.MemberInfo.Position === 'None'
        || vm.MemberInfo.Education === ''
        || vm.MemberInfo.Introduction === ''
        || vm.selectCity === 'null'
        || vm.selectDistrict === 'null'
      ) {
        vm.$swal({
          icon: 'warning',
          text: '請確實填寫會員資料',
          confirmButtonText: '確定',
        });
      } else {
        vm.$store.dispatch('updateLoading', true);
        API.getUpdateProfile(vm.token, vm.MemberInfo).then((res) => {
          vm.$store.dispatch('updateLoading', false);
          if (vm.IsUpdated) {
            if (res.status === 200) {
              vm.$swal({
                icon: 'success',
                text: '會員資料更新成功!',
                confirmButtonText: '確定',
              }).then(() => {
                // location.href = "/Member/Status";
              });
            } else {
              vm.$swal({
                icon: 'warning',
                text: '會員資料更新失敗，請稍後再試或連繫系統工程師!',
                confirmButtonText: '確定',
              });
            }
          } else {
            vm.joinMember();
          }
        });
      }
    },
    resetMember() {
      const vm = this;
      if (vm.IsUpdated) {
        vm.$set(vm.MemberInfo, 'City', '');
        vm.$set(vm.MemberInfo, 'District', '');
        vm.$set(vm.MemberInfo, 'Address', '');
        vm.$set(vm.MemberInfo, 'ContactBox', '');
        vm.$set(vm.MemberInfo, 'Mobile', '');
        vm.$set(vm.MemberInfo, 'Telephone', '');
        // vm.$set(vm.MemberInfo, 'Affiliation', '');
        // vm.$set(vm.MemberInfo, 'Position', '');
        vm.selectCity = 'null';
        vm.selectDistrict = 'null';
      } else {
        vm.$set(vm.MemberInfo, 'Name', '');
        vm.$set(vm.MemberInfo, 'EngName', '');
        vm.$set(vm.MemberInfo, 'IDcard', '');
        vm.$set(vm.MemberInfo, 'Education', '');
        vm.$set(vm.MemberInfo, 'Diploma', '');
        vm.$set(vm.MemberInfo, 'Certification', '');
        vm.$set(vm.MemberInfo, 'SpecialistNumber', '');
        vm.$set(vm.MemberInfo, 'Gender', null);
        vm.$set(vm.MemberInfo, 'Birthday', '');
        vm.$set(vm.MemberInfo, 'City', null);
        vm.$set(vm.MemberInfo, 'District', null);
        vm.$set(vm.MemberInfo, 'Address', '');
        vm.$set(vm.MemberInfo, 'ContactBox', '');
        vm.$set(vm.MemberInfo, 'Mobile', '');
        vm.$set(vm.MemberInfo, 'Affiliation', '');
        vm.$set(vm.MemberInfo, 'Position', 'None');
        vm.$set(vm.MemberInfo, 'Introducer', '');
        vm.$set(vm.MemberInfo, 'IntroducerEmail', '');
        vm.$set(vm.MemberInfo, 'SecondIntroducer', '');
        vm.$set(vm.MemberInfo, 'SecondIntroducerEmail', '');
        vm.$set(vm.MemberInfo, 'ResidentTrainStartOn', '');
        vm.$set(vm.MemberInfo, 'ResidentTrainEndOn', '');
        vm.$set(vm.MemberInfo, 'RetinaTrainStartOn', '');
        vm.$set(vm.MemberInfo, 'RetinaTrainEndOn', '');
      }
    },
    senMail() {
      const vm = this;
      const ValidationUrl = 'https://www.tadhtw.org/register';
      vm.$store.dispatch('updateLoading', true);
      API.SendEmail(vm.token, JSON.stringify(ValidationUrl)).then((res) => {
        vm.$store.dispatch('updateLoading', false);
        if (res.status === 200) {
          // console.log(res);
          vm.$swal({
            icon: 'success',
            text: '驗證信已寄出',
            confirmButtonText: '確定',
          });
        } else {
          vm.$swal({
            icon: 'warning',
            text: res.data.Message,
            confirmButtonText: '確定',
          });
        }
      });
    },
    setMemberStatus() {
      const vm = this;
      // 設定會員狀態
      if (!vm.MemberInfo.IsEmailValid) {
        vm.memberStatus = 10; // 信箱未驗證
      } else if (!vm.IsUpdated) {
        vm.memberStatus = 20; // 未填寫資料
      } else if (vm.MemberInfo.AuditStatus === 'None') {
        vm.memberStatus = 30; // 未繳費
      } else if (
        vm.MemberInfo.Position === 'Student'
        && vm.MemberInfo.AuditStatus === 'Processing'
        && vm.MemberInfo.IsUploadDiplomaPhotocopy === false
      ) {
        vm.memberStatus = 30; // 未上傳資料(學生)
      } else if (vm.MemberInfo.AuditStatus === 'Processing') {
        vm.memberStatus = 40; // 審核中
      } else if (vm.MemberInfo.AuditStatus === 'Fail') {
        vm.memberStatus = 50; // 審核未過
      } else if (
        vm.MemberInfo.AuditStatus === 'Success'
        && vm.MemberInfo.StartOn === undefined
      ) {
        vm.memberStatus = 60; // 未繳費
      } else {
        vm.memberStatus = 70; // 正式會員
      }
    },
    getActivityOrders(page) {
      const vm = this;
      API.getActivityOrders(page, vm.token).then((res) => {
        // console.log(res);
        if (res.status === 200) {
          if (vm.payedEvent.length === 0) {
            vm.busy = false;
            vm.payedEvent = res.data.Data.Orders;
            vm.totalPage = Math.ceil(parseInt(res.data.Data.Total, 10) / 10); // 指定為10進位
          } else if (vm.payedEvent.length !== 0 && vm.busy) {
            vm.busy = false;
            vm.$store.dispatch('updateLoading', false);
            vm.payedEvent = vm.payedEvent.concat(res.data.Data.Orders);
          }
        }
      });
    },
    getActivityRecord(page) {
      const vm = this;
      API.getActivityRecord(page, vm.token).then((res) => {
        // console.log(res);
        if (res.status === 200) {
          if (vm.eventRecord.length === 0) {
            vm.busyRecord = false;
            vm.eventRecord = res.data.Data.Records;
            vm.totalPageRecord = Math.ceil(
              parseInt(res.data.Data.Total, 10) / 10,
            ); // 指定為10進位
          } else if (vm.eventRecord.length !== 0 && vm.busyRecord) {
            vm.busyRecord = false;
            vm.$store.dispatch('updateLoading', false);
            vm.eventRecord = vm.eventRecord.concat(res.data.Data.Records);
          }
        }
      });
    },
    loadMore() {
      const vm = this;
      vm.busy = true;
      if (vm.totalPage === 1 || vm.totalPage === vm.nowPage) {
        vm.busy = false;
      } else {
        vm.$store.dispatch('updateLoading', true);
        vm.nowPage += 1;
        vm.getActivityOrders(vm.nowPage);
      }
    },
    loadMoreRecord() {
      const vm = this;
      vm.busyRecord = true;
      if (vm.totalPageRecord === 1 || vm.totalPageRecord === vm.nowPageRecord) {
        vm.busyRecord = false;
      } else {
        vm.$store.dispatch('updateLoading', true);
        vm.nowPageRecord += 1;
        vm.getActivityRecord(vm.nowPageRecord);
      }
    },
    joinMember() {
      const vm = this;
      vm.$store.dispatch('updateLoading', true);
      API.getJoinTrs(vm.token).then((res) => {
        // console.log(res.data.Data.OrderId, res.data.Data.Token);
        vm.$store.dispatch('updateLoading', false);
        if (res.status === 200 && res.data.Message !== 'Already membership!') {
          vm.payInfo.OrderId = res.data.Data.OrderId;
          vm.PaymentUrl = res.data.Data.PaymentUrl;
          vm.payInfo.Token = res.data.Data.Token;
          vm.payInfo.ReturnUrl = window.location.href;
          setTimeout(() => {
            document.getElementById('submitData').click();
          }, 1000);
          // location.href = res.Data;
        } else if (
          res.status === 200
          && res.data.Message === 'Already membership!'
        ) {
          vm.$swal({
            icon: 'warning',
            text: '您已是本會會員，請聯絡本會協助處理',
            confirmButtonText: '確定',
          });
        }
      });
    },
    onFileChange(e, index, type) {
      const vm = this;
      const files = e.target.files || e.dataTransfer.files;
      // console.log(files);
      if (files[0].size >= 6000000) {
        vm.$swal({
          type: 'warning',
          text: '檔案大小超過 6MB，請重新選擇檔案',
          confirmButtonText: '確定',
        });
        return false;
      }
      if (!files.length) return;
      vm.$set(vm.files, index, files[0].name);
      const updatefile = new FormData();
      updatefile.append(type, files[0]);

      // console 用
      // for (let key of updatefile.entries()) {
      //   console.log(key[0] + ", " + key[1]);
      // }
      API.getUpdateFile(type, vm.token, updatefile).then((res) => {
        // console.log(res);
        if (res.status !== 200) {
          vm.$swal({
            icon: 'warning',
            text: '檔案類型不正確，請上傳PDF檔案。',
            confirmButtonText: '確定',
          });
          vm.$set(vm.files, index, '');
        }
      });
    },
    deleteFile(index) {
      const vm = this;
      const files = vm.$refs[`file${index}`];
      files.value = '';
      vm.$set(vm.files, index, '');
    },
    resetFile() {
      const vm = this;
      vm.$refs[`file${0}`].value = '';
      vm.$set(vm.files, 0, '');
    },
    sendfile() {
      const vm = this;
      vm.$store.dispatch('updateLoading', true);
      API.getCheckFile(vm.token).then((res) => {
        vm.$store.dispatch('updateLoading', false);
        if (res.status === 200) {
          vm.$swal({
            icon: 'success',
            text: '已成功上傳檔案，已等候約3~5個工作天審核。',
            confirmButtonText: '確定',
          }).then(() => {
            window.location.reload();
          });
        }
        // if (res.Ok) {
        //   vm.popupshow = true;
        // }
      });
    },
    renewalMember() {
      const vm = this;
      vm.$store.dispatch('updateLoading', true);
      API.getRenewalTrs(vm.token).then((res) => {
        // console.log(res.data.Data.OrderId, res.data.Data.Token);
        vm.$store.dispatch('updateLoading', false);
        if (res.status === 200) {
          vm.payInfo.OrderId = res.data.Data.OrderId;
          vm.PaymentUrl = res.data.Data.PaymentUrl;
          vm.payInfo.Token = res.data.Data.Token;
          vm.payInfo.ReturnUrl = window.location.href;
          setTimeout(() => {
            document.getElementById('submitData').click();
          }, 1000);
          // location.href = res.Data;
        }
      });

      // 10/19 暫時以彈出視窗取代繳費功能
      // vm.$swal({
      //       type: "warning",
      //       text: "年會期間暫時關閉線上繳費功能，請於年會上繳納，或於年會結束後再使用線上繳費功能。",
      //       confirmButtonText: "確定"
      //     });
    },
    goPrint(id) {
      const vm = this;
      vm.$swal({
        text: '請輸入抬頭，如未輸入則預設為會員名稱',
        input: 'text',
        confirmButtonText: '確定',
      }).then((result) => {
        vm.$swal({
          text: '請輸入統一編號，如未輸入則預設為會員身分證字號',
          input: 'text',
          confirmButtonText: '確定',
        }).then((resultID) => {
          API.getPrintMember(id, vm.token).then((res) => {
            if (res.status === 200) {
              const data = res.data.Data;
              let tmpItems = '';
              let tmpResult = '';
              for (let i = 0; i < 7; i += 1) {
                if (i < data.items.length) {
                  if (i === 0) {
                    tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;border-left: 2px solid #000;padding: 5px;">${
  data.items[i].Title
}</td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;">${
  data.items[i].Amount
}</td>
        <td style="border: 1px solid #000;border-right: 2px solid #000;" rowspan="7">
        <div style="display:flex;justify-content:space-around;align-items: end;">
        <img style="width:50%;" src="${require('@/assets/images/receipt/台灣口腔衛生科學學會大章.png')}" alt="">
        <img src="${require('@/assets/images/receipt/黃曉靈理事長小章.jpg')}" alt="">
        </div>
        </td>
      </tr>`;
                  } else {
                    tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;border-left: 2px solid #000;padding: 5px;">${data.items[i].Title}</td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;">${data.items[i].Amount}</td>
      </tr>`;
                  }
                } else if (i === 6) {
                  tmpItems += `<tr>
        <td style="font-size: 14pt;border: 1px solid #000;border-left: 2px solid #000;padding: 5px;text-align: center;" colspan="2">
        合計新台幣：<span style="font-weight: bold;">${vm.ToString(
    data.TotalAmount,
  )}</span>
        </td>
      </tr>`;
                } else {
                  tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;border-left: 2px solid #000;padding: 5px;"></td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;padding: 5px;height: 24px;"></td>
      </tr>`;
                }
              }
              tmpItems += `<tr>
        <td style="font-size: 12pt;border: 1px solid #000;border-left: 2px solid #000;border-bottom: 2px solid #000;padding: 5px;" colspan="2"></td>
        <td style="text-align: center;font-size: 12pt;border: 1px solid #000;border-bottom: 2px solid #000;border-right: 2px solid #000;padding: 5px;height: 24px;">
        </td>
      </tr>`;
              // tmpItems += `<tr>
              //   <td style="font-size: 12pt;border: 1px solid #000;border-left: 2px solid #000;border-bottom: 2px solid #000;padding: 5px;" colspan="2"></td>
              //   <td style="text-align: center;font-size: 12pt;border: 1px solid #000;border-bottom: 2px solid #000;border-right: 2px solid #000;padding: 5px;height: 24px;">
              //   <div style="display:flex;align-items:center;">經辦人：<img style="width: 50px;" src="${require('@/assets/images/receipt/連續章(有框).jpg')}" alt=""></div>
              //   </td>
              // </tr>`;
              tmpResult = `<div>
          <img src="" alt="" style="position: absolute;top: 0;left: 0;margin-top: 18px;width: 180px;display:none;">
  <img src="" alt="" style="position: absolute;top: 0;left: 50%;transform: translateX(-50%);width: 110px;display:none;">
  <h1 style="text-align: center;font-size: 20pt;font-weight: bold;margin-bottom: 5px;">台灣口腔衛生科學學會收費收據</h1>
  <p style="font-size: 12pt;">姓名/抬頭： ${
  result.value ? result.value : data.Name
}</p>
  <div style="display: flex;justify-content: space-between;">
  <p style="font-size: 12pt;">身分證字號/統編： ${
  resultID.value ? resultID.value : vm.MemberInfo.IDcard
}</p>
  <p style="font-size: 12pt;">${data.OrderPayOn}</p>
  </div>
  <table style="width: 100%;border-spacing: 0px;">
    <thead>
      <tr>
      <th style="text-align: center;font-size: 12pt;width: 35%;padding: 5px;border: 1px solid #000;border-left: 2px solid #000;border-top: 2px solid #000;">
      項目
      </th>
      <th style="text-align: center;font-size: 12pt;width: 15%;padding: 5px;border: 1px solid #000;border-top: 2px solid #000;">
      金額
      </th>
      <th style="text-align: center;font-size: 12pt;width: 50%;padding: 5px;border: 1px solid #000;border-top: 2px solid #000;border-right: 2px solid #000;">
      台灣口腔衛生科學學會專用章
      </th>
      </tr>
    </thead>
    <tbody>
      ${tmpItems}
      <tr>
        <td style="font-size: 12pt;padding: 5px;" colspan="2">台灣口腔衛生科學學會</td>
        <td style="text-align: left;font-size: 12pt;padding: 5px;height: 24px;">聯絡資訊</td>
      </tr>
      <tr>
        <td style="font-size: 12pt;padding: 5px;" colspan="2">立案證號：台內社字第0950020618號</td>
        <td style="text-align: left;font-size: 12pt;padding: 5px;height: 24px;">電話：07-3121101轉2159</td>
      </tr>
      <tr>
        <td style="font-size: 12pt;padding: 5px;" colspan="2">統一編號：08919073</td>
        <td style="text-align: left;font-size: 12pt;padding: 5px;height: 24px;">E-Mail:oralhealth.taiwan@gmail.com</td>
      </tr>
      <tr>
        <td style="font-size: 12pt;padding: 5px;" colspan="2"></td>
        <td style="text-align: left;font-size: 12pt;padding: 5px;height: 24px;">會址：高雄市三民區十全一路100號</td>
      </tr>
    </tbody>
    </table>
    `;
              const printWindow = window.open('', '', 'height=400,width=800');
              printWindow.document.write(tmpResult);
              printWindow.document.close();
              setTimeout(() => {
                printWindow.print();
              }, 1000);
            } else {
              vm.$swal({
                type: 'warning',
                text: '請稍後再試。',
                confirmButtonText: '確定',
              });
            }
          });
        });
      });
    },
    ToString(n) {
      if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
        return '錯誤';
      }
      let returnText = '';

      if (n == 0) {
        returnText = '零元整';
      } else {
        let unit = '仟佰拾億仟佰拾萬仟佰拾元角分';
        let str = '';
        n += '00';

        const indexpoint = n.indexOf('.');

        if (indexpoint >= 0) {
          n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2);
        }

        unit = unit.substr(unit.length - n.length);
        for (let i = 0; i < n.length; i++) {
          str += '零壹貳參肆伍陸柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
        }

        returnText = str
          .replace(/零(仟|佰|拾|角)/g, '零')
          .replace(/(零)+/g, '零')
          .replace(/零(萬|億|元)/g, '$1')
          .replace(/(億)萬|壹(拾)/g, '$1$2')
          .replace(/^元零?|零分/g, '')
          .replace(/元$/g, '元整');
      }
      return returnText;
    },
    getFeeOrdersList() {
      const vm = this;
      const getData = {
        count: 100,
        leaf: 1,
      };
      API.getFeeOrders(getData, vm.token).then((res) => {
        if (res.status === 200) {
          const tmpData = res.data.Data.Orders;
          if (tmpData.length > 0) {
            vm.feeList = tmpData.filter((item) => item.IsPaid);
          }
        }
      });
    },
    openQRPop(item) {
      const vm = this;
      vm.qr.value = item;
      vm.openQR = true;
    },
  },
  created() {
    const vm = this;
    // vm.from = vm.$route.query.data;
    vm.from = vm.$route.params.data;
    if (vm.from === 'payedDetail') {
      vm.title = '活動訂單(收據)';
    }
    // this.screenWidth = window.innerWidth;
    // 綁定 resize 事件
    // window.addEventListener('resize', this.reSize);

    // 取得 cookie
    if (Common.getCookie('token')) {
      vm.isLogin = true;
      vm.token = Common.getCookie('token');
    }
    if (!vm.isLogin) {
      vm.openLoginbox();
    }
    // 取得會員資料
    if (vm.isLogin) {
      API.Profile(vm.token).then((res) => {
        if (res.status === 200) {
          vm.MemberInfo = res.data.Data;
          vm.StartDate = res.data.Data.StartOn;
          vm.EndDate = res.data.Data.EndOn;
          if (
            new Date().getFullYear()
            > new Date(vm.MemberInfo.EndOn).getFullYear()
          ) {
            vm.IsRenew = true;
          }
          if (!vm.MemberInfo.Name) {
            vm.IsUpdated = false;
          } else {
            vm.IsUpdated = true;
            if (vm.MemberInfo.City) {
              (async () => {
                vm.selectCity = await vm.MemberInfo.City;
                // console.log(vm.selectCity);
                vm.DistrictArea = await Common.Area(vm.selectCity);
                // console.log(vm.DistrictArea);
                vm.selectDistrict = await vm.MemberInfo.District;
                vm.$set(vm.MemberInfo, 'District', vm.selectDistrict);
                vm.$set(
                  vm.MemberInfo,
                  'Birthday',
                  vm.$moment(vm.MemberInfo.Birthday).format('YYYY-MM-DD'),
                );
              })();
            }
          }
          vm.setMemberStatus();
        }
      });
      vm.getActivityOrders(vm.nowPage); // 取得報名活動資料
      vm.getActivityRecord(vm.nowPageRecord);
      vm.getFeeOrdersList();
    }
    if (Common.GetUrlParams('status') === '200') {
      API.checkStatus(Common.GetUrlParams('id'), vm.token).then((res) => {
        // console.log(res);
      });
    }

    // vm.getActivityOrders(vm.nowPage); // 取得報名活動資料
    // vm.getActivityRecord(vm.nowPageRecord);
    vm.refreshCode(); // 初始化圖形驗證
    vm.ContributionListData = [
      {
        Title: '推廣及實踐口腔健康的促進健康的促進健康的促進健康的促進',
        Date: '2020.07.23',
        Number: '20123456789',
        Content: '推廣及實踐口腔健康的促進健康健康的促進健康的促進健康的促進',
        Status: false,
        Type: '研討會投稿',
      },
      {
        Title: '推廣及實踐口腔健康的促進健康的促進',
        Date: '2020.07.23',
        Number: '20123456789',
        Content: '推廣及實踐口腔健康的促進健康',
        Status: false,
        Type: '專題投稿',
      },
      {
        Title: '推廣及實踐口腔健康的促進健康的促進',
        Date: '2020.07.23',
        Number: '20123456789',
        Content: '推廣及實踐口腔健康的促進健康',
        Status: true,
        Type: '雜誌投稿',
      },
    ];
    vm.CityArea = Common.Area();
  },
  computed: {
    filterContributionList() {
      const vm = this;
      let tmpList = [];
      if (vm.nowIndex === 1) {
        tmpList = vm.ContributionListData.filter(
          (item) => item.Type === '雜誌投稿',
        );
      } else if (vm.nowIndex === 2) {
        tmpList = vm.ContributionListData.filter(
          (item) => item.Type === '專題投稿',
        );
      } else if (vm.nowIndex === 3) {
        tmpList = vm.ContributionListData.filter(
          (item) => item.Type === '研討會投稿',
        );
      } else {
        tmpList = vm.ContributionListData;
      }
      return tmpList;
    },
    screenWidth() {
      return this.$store.state.screenWidth;
    },
    // isLogin() {
    //   return this.$store.state.isLogin;
    // },
    showtext() {
      const vm = this;
      let returnText = '';
      switch (vm.memberStatus) {
        case 10:
          returnText = '帳號驗證中(等候驗證)';
          break;
        case 20:
          returnText = '帳號註冊完成(未填寫資料)';
          break;
        case 30:
          if (vm.MemberInfo.AuditStatus !== 'Processing') {
            returnText = '未繳費';
            break;
          } else {
            returnText = '繳費完成(請上傳申請入會資料)';
            break;
          }
        case 40:
          returnText = '帳號註冊完成(審核中)';
          break;
        case 50:
          returnText = '繳費完成(申請入會-待補資料)';
          break;
        case 60:
          returnText = '已完成會員認證(未繳費)';
          break;
        case 70:
          returnText = '正式會員';
          break;
        default:
          break;
      }
      return returnText;
    },
  },
  mounted() {},
  watch: {
    selectCity: {
      // immediate: false,
      handler(newValue, oldValue) {
        // console.log(newValue);
        const vm = this;
        // console.log(oldValue);
        vm.$set(vm.MemberInfo, 'City', newValue);
        if (oldValue == null || oldValue === 'null') {
          vm.DistrictArea = Common.Area(newValue);
        } else {
          vm.DistrictArea = Common.Area(newValue);
          vm.selectDistrict = null;
          vm.$set(vm.MemberInfo, 'District', null);
        }
      },
    },
    selectDistrict: {
      handler(value) {
        const vm = this;
        if (value == null || value === 'null') {
        } else {
          vm.$set(vm.MemberInfo, 'District', value);
        }
      },
    },
  },
  filters: {
    dayFormat(data) {
      let tmpDay = '';
      if (data) {
        tmpDay = data.split('-')[2];
      }
      return tmpDay;
    },
    monthFormat(data) {
      let tmpMonth = '';
      if (data) {
        tmpMonth = data.split('-');
      }
      switch (tmpMonth[1]) {
        case '01':
          tmpMonth = 'JAN';
          break;
        case '02':
          tmpMonth = 'FEB';
          break;
        case '03':
          tmpMonth = 'MAR';
          break;
        case '04':
          tmpMonth = 'APR';
          break;
        case '05':
          tmpMonth = 'MAY';
          break;
        case '06':
          tmpMonth = 'JUN';
          break;
        case '07':
          tmpMonth = 'JUL';
          break;
        case '08':
          tmpMonth = 'AUG';
          break;
        case '09':
          tmpMonth = 'SEP';
          break;
        case '10':
          tmpMonth = 'OCT';
          break;
        case '11':
          tmpMonth = 'NOV';
          break;
        case '12':
          tmpMonth = 'DEC';
          break;

        default:
          break;
      }
      return tmpMonth;
    },
    yearFormat(data) {
      let tmpYear = '';
      if (data) {
        tmpYear = data.split('-')[0];
      }
      return tmpYear;
    },
    weekFormat(data) {
      let tmpWeek = '';
      if (data) {
        tmpWeek = new Date(data).getDay();
      }
      switch (tmpWeek) {
        case 0:
          tmpWeek = '星期日';
          break;
        case 1:
          tmpWeek = '星期一';
          break;
        case 2:
          tmpWeek = '星期二';
          break;
        case 3:
          tmpWeek = '星期三';
          break;
        case 4:
          tmpWeek = '星期四';
          break;
        case 5:
          tmpWeek = '星期五';
          break;
        case 6:
          tmpWeek = '星期六';
          break;
        default:
          break;
      }
      return tmpWeek;
    },
    feeDisplay(data) {
      let tmpFee = '';
      if (data === 'Student') {
        tmpFee = 500;
      } else {
        tmpFee = 1000;
      }
      return tmpFee;
    },
    nameDisplay(data) {
      let tmpName = '';
      switch (data) {
        case data === 'Doctor':
          tmpName = '醫師';
          break;
        case data === 'Dentist':
          tmpName = '牙醫師';
          break;
        case data === 'DentalHygienist':
          tmpName = '口衛師';
          break;
        case data === 'DentistAssistant':
          tmpName = '牙助';
          break;
        case data === 'Nurse':
          tmpName = '護理師';
          break;
        case data === 'SpeechTherapist':
          tmpName = '語言治療師';
          break;
        case data === 'Nutritionist':
          tmpName = '營養師';
          break;
        case data === 'Caregiver':
          tmpName = '照服員';
          break;
        case data === 'Lecturer':
          tmpName = '講師';
          break;
        case data === 'Student':
          tmpName = '學生';
          break;
        default:
          break;
      }
      return tmpName;
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  z-index: 999;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
.popup .title {
  width: 60%;
  margin: 60px auto 20px;
  font-size: 1.3rem;
  position: relative;
  line-height: 1.5;
}
.popup .title .close {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 600;
  cursor: pointer;
}
.popup .slider {
  width: 100%;
  height: calc(100% - 100px);
}
/* 套件 */
// .swiper-container {
//   box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
//   background-color: #fff;
// }
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.gallery-top {
  height: 80% !important;
  width: 60%;
}
.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
.swiper-button-prev,
.swiper-button-next {
  background-color: #fff;
  background-size: 20px 15px;
  width: 25px;
  height: 50px;
  border: 1px solid #b8b8b8;
}

.swiper-button-prev:hover,
.swiper-button-next:hover {
  background-color: #001139;
}
.gallery-top .swiper-slide {
  background-size: contain;
  background-repeat: no-repeat;
}
/* 套件END */
@media screen and (max-width: 992px) {
  #silhouette .list_box .list .item {
    width: 48%;
  }
}
@media screen and (max-width: 767px) {
  #silhouette .list .list_box {
    margin-bottom: 60px;
  }

  #silhouette .list_box .list .item {
    width: 100%;
    max-width: 100%;
  }
  .popup .title {
    width: 80%;
  }
  /* 套件 */
  .gallery-top {
    height: 80% !important;
    width: 80%;
  }
}

.no-Login {
  text-align: center;

  h3 {
    margin-bottom: 1.5rem;
  }

  .blue-btn {
    margin-right: 0;
  }
}

.eventCard-date {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #001139;
  transition: all 0.5s;
  margin-right: 0;
}

.eventCard-date-month {
  line-height: 1;
  .day {
    font-size: 2.75rem;
    line-height: 1;
  }

  .month {
    font-size: 1.5rem;
  }
}

.eventCard-date-year {
  writing-mode: vertical-lr;
  font-size: 1.75rem;
  line-height: 1;

  // @media (max-width: 1024px) {
  //   margin-right: 1rem;
  // }
}

.member-box {
  .input_span {
    .sex {
      width: 100%;
      padding: 2px 20px;
    }

    span {
      width: 170px;
    }

    .select {
      width: 100%;
      text-align: left;

      select {
        padding: 2px 20px;
        margin-bottom: 1rem;
        width: 47%;
        margin-right: 1rem;
      }
      select:first-child {
        margin-right: 1rem;
      }
    }
  }
}

.cost .signtpye {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-inline-start: 0;
}
.box .cost .signtpye li {
  padding: 8px 16px;
  display: flex;
  font-size: 1.3rem;
}
.box .cost .signtpye li > span:nth-child(1) {
  margin-right: 16px;
  color: #666;
}
.box .cost .signtpye li > span:nth-child(2),
.box .total > span:nth-child(2) {
  min-width: 110px;
  text-align: right;
}

.cost-container {
  padding: 30px 0;
  @media (max-width: 420px) {
    padding: 10px;
  }

  .title {
    text-align: right;
    padding: 10px 10px;

    &.isMember {
      background-color: #f68e56;
      color: #fff;
      font-size: 1.3rem;
    }
  }
  .input_span {
    // 讓下拉選單文字靠右
    select {
      width: 100%;
      text-align: right;
      text-align-last: right;
      color: #666;

      option {
        direction: rtl;
      }
    }
  }
}

.global_title {
  width: 100%;
  padding: 8px 16px;
  border-bottom: 1px solid #696969;
  font-size: 1.4rem;
  margin-bottom: 10px;
}

.detail {
  padding-top: 50px;
}

.detail .box .total {
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px;
  color: #c0272d;
  font-size: 1.3rem;
}
.detail .box .total span:nth-child(1) {
  margin-right: 16px;
}

.file_item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 58px;
}
.file_item > span {
  width: 170px;
  margin-right: 10px;
}
.file_item > label {
  display: flex;
  align-items: center;
}
.file_item > label > span:nth-child(1) {
  background-color: #a59b92;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  padding: 5px 20px;
}
.file_item input {
  display: none;
}
.file_item .file_name {
  display: flex;
  align-items: center;
}
.file_item .file_name > div:nth-child(1) {
  border: 1px solid #eee;
  padding: 10px 12px;
  min-width: 250px;
  display: flex;
  align-items: center;
}
.file_item .file_name > div:nth-child(2) {
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.file_item .file_name > div:nth-child(2) span:nth-child(1) {
  color: #f00;
  font-weight: 600;
  padding: 0 10px;
  font-size: 1.5rem;
}

.item_status .status {
  color: #f00;
}

.member-activity {
  @media (max-width: 767px) {
    flex-direction: column;

    .member-activity-info {
      margin: auto;
    }
  }
}
</style>
